import { InventoryType } from "gen/ApiClient";

export const hasLength = (type: InventoryType) => {
    if (type === 'SkiComfort' || type === 'SkiJunior' || type === 'SkiVip' || type === 'Snowboard' || type === 'SnowboardJunior' || type === 'SkiTour') {
        return true;
    } else {
        return false;
    }
}